module.exports = __webpack_public_path__ + "assets/img/failed_icon.11dd765c.svg";